import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import axios from "axios";
import { createMetaManager } from "vue-meta";
import { PublicClientApplication } from "@azure/msal-browser";
import msalConfig from "./msalConfig";
import VueApexCharts from "vue3-apexcharts";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import "./assets/fonts.css";

const initializeMsal = async () => {
  const msalInstance = new PublicClientApplication(msalConfig);
  await msalInstance.initialize();
  return msalInstance;
};

const initializeApp = async (app) => {
  try {
    const msalInstance = await initializeMsal();
    await msalInstance.handleRedirectPromise();
    app.provide("$msalInstance", msalInstance);
    app.provide("$msalError", null);
  } catch (error) {
    app.provide("$msalInstance", null);
    app.provide("$msalError", error?.message || "MSAL initialization failed");
  }
};

const i18n = createI18n({
  locale: "en",
  messages: {
    en,
    fr,
  },
});

loadFonts();

axios.defaults.headers.post["Accept"] = "application/json";
axios.defaults.headers.post["Content-Type"] = "application/json";

axios.defaults.baseURL = process.env.VUE_APP_HOST;

const app = createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(VueApexCharts)
  .use(i18n)
  .use(createMetaManager());

initializeApp(app).finally(() => {
  app.mount("#app");
});
